module.exports = __webpack_public_path__ + "img/student_empty_icon.9e081a5b.png";